import {
  Box,
  Button,
  Flex,
  Grid,
  Select,
  Textarea,
  TextInput,
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconCheck } from "@tabler/icons-react";
import { useState } from "react";
import { repositoryMdm } from "../../../_base/_const/_constVar";
import { MessageResponse } from "../../../model/MessageResponse";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { modals } from "@mantine/modals";

interface dataSubmit {
  id: number;
  attribute16: string;
  attribute17: string;
  attribute18: string;
  attribute19: string;
  attribute20: string;
  attribute13: number | null;
}

const TransferShippingFromInv = ({
  onSuccess,
  dataRequestTransfer,
}: {
  onSuccess: any;
  dataRequestTransfer: any;
}) => {
  const [dataSubmit, setDataSubmit] = useState<dataSubmit>({
    id: dataRequestTransfer.id || 0,
    attribute16: "Đã đẩy đơn sang GV thứ 3 khác !",
    attribute17: "",
    attribute18: "",
    attribute19: "DA_DONG_GOI",
    attribute20: "",
    attribute13: dataRequestTransfer.attribute13 || null,
  });
  const [deliveryMore, setDeliveryMore] = useState<string>("");

  const [visible, { toggle, open, close }] = useDisclosure(false);
  const [isSubmit, setIsSubmit] = useState<boolean>(false);

  const handleSubmit = async () => {
    open();
    setIsSubmit(true);

    if (!dataSubmit.attribute17 || dataSubmit.attribute17.length === 0) {
      NotificationExtension.Fails("Vui lòng chọn đơn vị vận chuyển !");
      close();
      return;
    }

    if (dataSubmit.attribute17 === "KHAC" && deliveryMore.length === 0) {
      NotificationExtension.Fails("Vui lòng nhập đơn vị vận chuyển khác !");
      close();
      return;
    }

    if (!dataSubmit.attribute18 || dataSubmit.attribute18.length === 0) {
      NotificationExtension.Fails("Vui lòng nhập mã vận đơn !");
      close();
      return;
    }

    try {
      const res = await repositoryMdm.post<MessageResponse<any>>(
        "/api/v1/TblRequestTransfer/update-attribute16",
        dataSubmit,
      );

      if (res && res.success) {
        NotificationExtension.Success(
          "Điều chuyển đơn vị giao hàng thành công !",
        );
        setTimeout(() => {
          modals.closeAll();
          onSuccess();
        }, 1000);
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  return (
    <Box w={"35vw"} maw={500}>
      <Grid mt={5}>
        <Grid.Col span={12}>
          <Select
            label={"Đối tác vận chuyển"}
            placeholder="Chọn đối tác vận chuyển"
            value={dataSubmit.attribute17 || null}
            data={[
              { label: "Nhất Tín", value: "NHAT_TIN" },
              { label: "Tín Thành", value: "TIN_THANH" },
              { label: "Nasco", value: "NASCO" },
              { label: "Viettel", value: "VIETTEL" },
              { label: "Khác", value: "KHAC" },
            ]}
            clearable
            onChange={(e) =>
              setDataSubmit((prev) => ({
                ...prev,
                attribute17: e ? e : "",
              }))
            }
            withAsterisk
            error={
              isSubmit &&
              (!dataSubmit.attribute17 || dataSubmit.attribute17.length === 0)
                ? "Vui lòng chọn đơn vị vận chuyển !"
                : false
            }
          />
        </Grid.Col>
        {dataSubmit.attribute17 === "KHAC" ? (
          <Grid.Col span={12}>
            <TextInput
              label="Đơn vị vận chuyển khác"
              placeholder="Nhập tên đơn vị vận chuyển khác"
              value={deliveryMore}
              onChange={(e) => setDeliveryMore(e.currentTarget.value)}
              withAsterisk
              error={
                isSubmit &&
                dataSubmit.attribute17 === "KHAC" &&
                deliveryMore.length === 0
                  ? "Vui lòng nhập đơn vị vận chuyển khác !"
                  : false
              }
            />
          </Grid.Col>
        ) : (
          <></>
        )}
        <Grid.Col span={12}>
          <TextInput
            label="Mã vận đơn"
            placeholder="Nhập mã vận đơn"
            value={dataSubmit.attribute18}
            onChange={(e) =>
              setDataSubmit((prev) => ({
                ...prev,
                attribute18: e.currentTarget.value,
              }))
            }
            withAsterisk
            error={
              isSubmit &&
              (!dataSubmit.attribute18 || dataSubmit.attribute18.length === 0)
                ? "Vui lòng nhập mã vận đơn !"
                : false
            }
          />
        </Grid.Col>
        <Grid.Col span={12}>
          <Textarea
            label="Ghi chú"
            placeholder="Nhập ghi chú"
            value={dataSubmit.attribute20}
            onChange={(e) =>
              setDataSubmit((prev) => ({
                ...prev,
                attribute20: e.currentTarget.value,
              }))
            }
          />
        </Grid.Col>
      </Grid>
      <Flex justify={"end"} gap={"md"} mt={5}>
        <Button
          leftSection={<IconCheck />}
          onClick={() => handleSubmit()}
          loading={visible}
          disabled={visible}
        >
          Lưu
        </Button>
      </Flex>
    </Box>
  );
};

export default TransferShippingFromInv;
